export const API_REDUCER_STATE_ID = 'api';
